export default __webpack_public_path__ + "static/media/denmark-flag-icon.d2c885f0.svg";